const initialState = {
    token: !!localStorage.getItem('token') ? localStorage.getItem('token') : false,
    profile: JSON.parse(localStorage.getItem('profile')) ? JSON.parse(localStorage.getItem('profile')) : {},
    mobile: '', // Input
    password: '', // Input
    disabledBtn: false,
    captchaImage: '',
    captcha: '', // Input
};

const login = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_INPUT_PAGE_LOGIN':
            return {...state, [action.name]: action.value};
       	case 'CHANGE_TOKEN':
            localStorage.setItem('token', action.token);
            return {...state, token: action.token};
        case 'CHANGE_PROFILE_DATA':
            localStorage.setItem('profile', JSON.stringify(action.info));
            return {...state, profile: action.info};
        case 'LOG_OUT_USER':
            localStorage.removeItem('token');
            localStorage.removeItem('profile');
            return {...initialState, token: false, profile: {}};
        default:
            return state;
    }
};

export default login;
